<template>
    <div class="infoframe">
        <div class="infohead">
            <div style="margin-left:32px">
                基础信息
            </div>
      
        </div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;为保证您的个性化定制项目准确合理，系统已自动设置项目除重和符合医学定制原则的项目互斥、项目关联、特殊项目提醒等。
       点选项目后页面下方会根据除重后项目金额实时显示折后价格和应付款金额。
       请您放心定制。
    </div>
        <el-form ref="form" :model="form" label-width="80px" class="infoform">
             <el-form-item label="单位名称">
                <el-input :readonly="true" v-model="form.company"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input :readonly="true" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
                <el-input :readonly="true" v-model="form.idnumber"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-input :readonly="true" v-model="form.gender"></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
                <el-input :readonly="true" v-model="form.dateofbirth"></el-input>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input :readonly="true" v-model="age"></el-input>
            </el-form-item>
        </el-form>
        <div style="text-align:center;top:20%">
        
        <el-button type="primary" @click="nextstep">开始定制</el-button>
        </div>
        
<el-dialog title="定制说明" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    
  

   <div  style="margin-bottom:10px;"> 为保证您的个性化定制项目准确合理，系统已自动设置项目除重和符合医学定制原则的项目互斥、项目关联、特殊项目提醒等。
       点选项目后页面下方会根据除重后项目金额实时显示折后价格和应付款金额。
       请您放心定制。</div>
 
<div style="text-align:center;margin-bottom:10px;">
   <el-button type="primary" @click="dialogTableVisible = false">知道了</el-button>
</div>
</el-dialog>
    </div>
</template>

<script>
  import {decrypt} from '../rest'
  import {restbase} from '../rest'
import {foowwLocalStorage} from '../rest'
    export default {
        name: 'info',
        data() {
            return {
                form: {
                    name: '',
                    idnumber: '',
                    gender: '',
                    dateofbirth: '',
                    company: '',
                    phone:'',
                    vcode:''
                },
                user:[],
                birth:new Date(),
                dialogTableVisible: true,
                formLabelWidth: '120px'
            }
        },
        created(){
        if (this.user.length == 0) {
               this.user=JSON.parse(foowwLocalStorage.get('user'));
               console.log(this.user);
            }
             this.form.idnumber=this.user.PaperValue;
            this.form.phone=this.user.Mobile;
            this.form.name = this.user.UserName;
            this.form.gender = this.user.Sex;
            this.form.company = this.user.CCompany;
			if (this.form.idnumber.length === 18) {
			const bd = this.form.idnumber.slice(6, 14);
			this.birth = moment(bd, "YYYYMMDD")
			this.form.dateofbirth = moment(this.birth).format('YYYY-MM-DD');
            }
        },
		mounted() {
           
           
            this.fetchFt2();
           
			
            
		},
        computed: {
           
            age() {
                let age = 0;
                let birthDate = new Date(this.birth);
                if (birthDate) {
                    const today = new Date();
                    age = today.getFullYear() - birthDate.getFullYear();
                    let m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
                    {
                        age--;
                    }
                }
                return age;
            }
        },
		methods: {
          
            nextstep() {
                //this.$root.gender = this.form.gender === '男' ? '01' : '10';
                this.$router.push('disease');
            },
            
               fetchFt2() {
                //读取基表2
            console.log(this.form.gender);
            let sex='10';
            if(this.form.gender=='男')
             {  sex='01';} 
                 console.log(sex);
                this.$http.get(restbase()+"ft2_new", {params:{gender:sex}})
                .then(response=>{
                   console.log(response);
                    foowwLocalStorage.set('ft2',JSON.stringify(response.data.data));
                    
                }, response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
            }
            
		}
    }
</script>

<style>
    .infoframe {
        position: relative;
        height: 100%;
        width:100%;
        margin:0 auto;
        border-radius: 4px;
        border-left: 1px solid #ddd;
        box-shadow: 3px 3px 3px #aaa;
        background-color: white;
    }
    .infohead {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .infoform {
        padding:  10% 10%  5%  5%;
    }
    .el-dialog{
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:40%;
       left:50%;
       transform:translate(-50%,-50%);
       /*height:600px;*/
       max-height:calc(100% - 30px);
       max-width:calc(100% - 30px);
   }
</style>